import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    Tab,
    Tabs,
} from "@material-ui/core";
import PropTypes from "prop-types";
import { ESTUDIOSMEDICOS_MENU_GESTION } from "../../../../utils/constants";
import { InformacionMenu } from "./InformacionMenu";
import { AfiliadoMenu } from "./AfiliadoMenu";
import { AdministrarMenu } from "./AdministrarMenu";
import { InformesMenu } from "./InformesMenu";
import { NotasMenu } from "./NotasMenu";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            name={index}
            {...other}
        >
            {value === index && <Box p={2}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
    };
}


export const ModalGestionarEstudio = (props) => {

    const [selectedTab, setSelectedTab] = useState(
        ESTUDIOSMEDICOS_MENU_GESTION.AFILIADO
    );

    const { estudioMedicoSeleccionado = {} } = useSelector(
        (state) => state.estudiosMedicos
    );

    const { open } = props;

    useEffect(() => {
        setSelectedTab(ESTUDIOSMEDICOS_MENU_GESTION.AFILIADO);
    }, [open, estudioMedicoSeleccionado?.id]);


    return (
        <Dialog
            fullWidth
            maxWidth="md"
            //   maxWidth="lg"
            open={open}
            onClose={props.closeModalHandler}
        >
            <DialogTitle>Estudio Solicitado N°{estudioMedicoSeleccionado?.id}</DialogTitle>
            <DialogContent>
                <Tabs
                    value={selectedTab}
                    onChange={(event, newValue) => setSelectedTab(newValue)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    <Tab
                        value={ESTUDIOSMEDICOS_MENU_GESTION.AFILIADO}
                        label="Afiliado"
                        {...a11yProps(ESTUDIOSMEDICOS_MENU_GESTION.AFILIADO)}
                    />
                    <Tab
                        value={ESTUDIOSMEDICOS_MENU_GESTION.INFORMACION}
                        label="Documentación"
                        {...a11yProps(ESTUDIOSMEDICOS_MENU_GESTION.AFILIADO)}
                    />
                    <Tab
                        value={ESTUDIOSMEDICOS_MENU_GESTION.INFORMES}
                        label="Informes"
                        {...a11yProps(ESTUDIOSMEDICOS_MENU_GESTION.INFORMES)}
                    />
                    <Tab
                        value={ESTUDIOSMEDICOS_MENU_GESTION.NOTAS}
                        label="Notas"
                        {...a11yProps(ESTUDIOSMEDICOS_MENU_GESTION.NOTAS)}
                    />
                    <Tab
                        value={ESTUDIOSMEDICOS_MENU_GESTION.ADMINISTRAR}
                        label="Administrar"
                        {...a11yProps(ESTUDIOSMEDICOS_MENU_GESTION.ADMINISTRAR)}
                    />
                </Tabs>
                <TabPanel
                    value={selectedTab}
                    index={ESTUDIOSMEDICOS_MENU_GESTION.AFILIADO}
                >
                    <AfiliadoMenu estudioMedicoSeleccionado={estudioMedicoSeleccionado} />
                </TabPanel>
                <TabPanel
                    value={selectedTab}
                    index={ESTUDIOSMEDICOS_MENU_GESTION.INFORMACION}
                >
                    <InformacionMenu estudioMedicoSeleccionado={estudioMedicoSeleccionado} />
                </TabPanel>
                <TabPanel
                    value={selectedTab}
                    index={ESTUDIOSMEDICOS_MENU_GESTION.INFORMES}
                >
                    <InformesMenu estudioMedicoSeleccionado={estudioMedicoSeleccionado} />
                </TabPanel>
                <TabPanel
                    value={selectedTab}
                    index={ESTUDIOSMEDICOS_MENU_GESTION.NOTAS}
                >
                    <NotasMenu estudioMedicoSeleccionado={estudioMedicoSeleccionado} />
                </TabPanel>
                <TabPanel
                    value={selectedTab}
                    index={ESTUDIOSMEDICOS_MENU_GESTION.ADMINISTRAR}
                >
                    <AdministrarMenu
                        closeModalAuditar={props.closeModalHandler}
                        filtros={props.filtros}
                        setOpenModalGestionar={props.setOpenModalGestionar} />

                </TabPanel>
            </DialogContent>
        </Dialog>
    )
}
